const axios = require('axios')

const functions =  {
    availableMethods() {
        return [
            'create'
        ]
    },

    async create(file, data = {}, options = {}, cancelKey) {
        data.extension = file.name.split('.').pop();
        const response = await this._callApi('/upload/signed-url', 'post', data, cancelKey);

        let headers = response.data.headers;

        if ('Host' in headers) {
            delete headers.Host;
        }

        if (typeof options.progress === 'undefined') {
            options.progress = () => {};
        }

        headers['x-amz-acl']  = headers['x-amz-acl'][0];

        await axios.put(response.data.url, file, {
            cancelToken: cancelKey,
            headers: headers,
            onUploadProgress: (progressEvent) => {
                options.progress(progressEvent.loaded / progressEvent.total);
            }
        })

        return response.data.key;
    }
}

export default functions
